import React from "react";
import { Navigate } from "react-router";

import Bots from "../../../views/pages/dashboard/admin/Bots";
import Affiliates from "../../../views/pages/dashboard/admin/stats/Affiliates";
import AffiliatesEarnings from "../../../views/pages/dashboard/admin/stats/AffiliatesEarnings";
import AffiliatesHierarchy from "../../../views/pages/dashboard/admin/stats/AffiliatesHierarchy";
import AffiliatesPayouts from "../../../views/pages/dashboard/admin/stats/AffiliatesPayouts";
import Distributors from "../../../views/pages/dashboard/admin/stats/Distributors";
import MRR from "../../../views/pages/dashboard/admin/stats/MRR";
import SignUps from "../../../views/pages/dashboard/admin/stats/SignUps";
import Users from "../../../views/pages/dashboard/admin/Users";
import type { RouteProps } from "../../routeTypes";

const subRoutes = (props: RouteProps) => {
  const { t } = props;
  return [
    {
      name: t("routes.admin.usersAndClients", { ns: "dashboard" }),
      path: "users",
      showOnNav: true,
      icon: "fas fa-users text-default",
      subRoutes: [
        {
          name: t("routes.admin.signUps", { ns: "dashboard" }),
          path: "sign-ups",
          showOnNav: true,
          component: <SignUps />,
        },
        {
          name: t("routes.admin.allUsers", { ns: "dashboard" }),
          path: "all",
          showOnNav: true,
          component: <Users />,
        },
        { path: "active-clients", component: <Navigate to="/stats/users/all?segment=clients" replace /> },
        { path: "non-client-users", component: <Navigate to="/stats/users/all?segment=nonClients" replace /> },
        { path: "vip-users", component: <Navigate to="/stats/users/all?segment=vip" replace /> },
      ],
    },
    {
      name: t("routes.admin.affiliates", { ns: "dashboard" }),
      path: "affiliates",
      showOnNav: true,
      icon: "fas fa-users text-default",
      subRoutes: [
        {
          name: t("routes.admin.distributors", { ns: "dashboard" }),
          path: "distributors",
          showOnNav: true,
          component: <Distributors />,
        },
        {
          name: t("routes.admin.affiliates", { ns: "dashboard" }),
          path: "",
          showOnNav: true,
          component: <Affiliates />,
        },
        {
          name: t("routes.admin.earningsPerAffiliate", { ns: "dashboard" }),
          path: "hierarchy-earnings",
          showOnNav: true,
          component: <AffiliatesEarnings />,
        },
        {
          name: t("routes.admin.affiliatesHierarchy", { ns: "dashboard" }),
          path: "affiliates-hierarchy",
          showOnNav: true,
          subRoutes: [
            {
              name: t("routes.admin.affiliatesHierarchy", { ns: "dashboard" }),
              path: "",
              component: <AffiliatesHierarchy />,
            },
            {
              name: t("routes.admin.affiliatesHierarchy", { ns: "dashboard" }),
              path: ":id",
              component: <AffiliatesHierarchy />,
            },
          ],
        },
        {
          name: t("routes.admin.payouts", { ns: "dashboard" }),
          path: "payouts",
          showOnNav: true,
          component: <AffiliatesPayouts />,
        },
      ],
    },
    {
      name: t("routes.admin.bots", { ns: "dashboard" }),
      path: "bots",
      showOnNav: true,
      icon: "fas fa-chart-bar text-default",
      subRoutes: [
        {
          name: t("routes.admin.activeBots", { ns: "dashboard" }),
          path: "",
          showOnNav: true,
          component: <Bots filtersToShow={["showOnlyOnLoss", "showOnlyStale"]} />,
        },
      ],
    },
    {
      name: t("routes.admin.financial", { ns: "dashboard" }),
      path: "financial",
      showOnNav: true,
      icon: "fas fa-cash-register text-default",
      subRoutes: [
        {
          name: t("routes.admin.mrr", { ns: "dashboard" }),
          path: "mrr",
          showOnNav: true,
          component: <MRR />,
        },
      ],
    },
  ];
};

export default subRoutes;
